import { FC } from 'react'

import {
  companyLinks,
  otherLinks,
  partnerLinks,
  policyLinks,
  simplifiedConditionsLink,
} from 'sections/PromoSection/pages/PromoPage/data'
import { ButtonPromo, TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Space } from 'components/ui/Space/Space'
import { Flex } from 'components/uiKit'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { PromoRoutesEnum } from 'shared/constants/routes'
import { URLS } from 'shared/constants/urls'
import { AdriverEventType, EventType } from 'types/types'

import { FooterLinksWrapper } from './components/FooterLinksWrapper'

import MobileLinkQr from 'assets/img/promo-page/mobileQr.svg?react'
import rutubeLogo from 'assets/img/promo-page/rutubeLogo.svg'
import logo from 'assets/img/promo-page/wb-logo.webp'
import youtubeLogo from 'assets/img/promo-page/youtubeLogo.svg'
import s from './Footer.module.scss'

export const Footer: FC = () => {
  const { isMobile, isSTablet, isSDesktop } = useResize()

  const handleSocialLinkClick = (linkLabel: string) => {
    sendEvent(EventType.FooterT, { name: linkLabel })
    sendAdriverEvent(AdriverEventType.socialIcons)
  }

  const appStoresList = !isSTablet && (
    <Flex vertical gap={16} style={{ marginRight: !isSDesktop ? '80px' : '0' }}>
      <TextPromo color="white" size={isSDesktop ? 's16' : 's20'} fontFamily="ASLHauss" weight="w500">
        Мобильное приложение
      </TextPromo>
      <MobileLinkQr className={s.qr} />
    </Flex>
  )

  const footNote = (
    <TextPromo size="s14" fontFamily="ASLHauss" color="greyInvert" className={s.disclaimer} center>
      © Wildberries 2004-2025. Все права защищены. Применяются рекомендательные технологии
    </TextPromo>
  )

  const socialIcons = (
    <Flex vertical={!isSTablet} gap={16} className={s.socialIcons}>
      <Href
        href={URLS.youtube}
        className={s.socialIconWrapper}
        linkType="search"
        target="_blank"
        onClick={() => handleSocialLinkClick('youtube')}
      >
        <img src={youtubeLogo} alt="youtube" className={s.socialIcon} />
      </Href>
      <Href
        href={URLS.rutube}
        className={s.socialIconWrapper}
        linkType="search"
        target="_blank"
        onClick={() => handleSocialLinkClick('rutube')}
      >
        <img src={rutubeLogo} alt="rutube" className={s.socialIcon} />
      </Href>
    </Flex>
  )

  const appDownloadButton = (
    <Href
      href={PromoRoutesEnum.apps}
      className={s.appLink}
      onClick={() => sendEvent(EventType.FooterT, { name: 'Скачать приложение' })}
    >
      <ButtonPromo className={s.downloadButton}>Скачать приложение</ButtonPromo>
    </Href>
  )

  return (
    <footer>
      <Space size={!isMobile ? 140 : 80} />
      <div className={s.footer}>
        <div className="contentWrapper">
          <Flex justify="space-between">
            <div>
              <img src={logo} alt="logo" className={s.logo} />
              {isSDesktop && socialIcons}
            </div>

            {isSDesktop && appStoresList}
          </Flex>

          <div className={s.linksBlock}>
            <Flex vertical gap={40}>
              {!isSDesktop && appStoresList}
            </Flex>
            <FooterLinksWrapper links={otherLinks} title="Обучение" />
            <FooterLinksWrapper links={[simplifiedConditionsLink, ...partnerLinks]} title="Партнёрам" />
            <FooterLinksWrapper links={companyLinks} title="Ремонт и оформление" wide />
            {!isSDesktop && socialIcons}
          </div>
          {isSTablet && appDownloadButton}
          <Flex vertical>
            <ul className={s.policyLinks}>
              {policyLinks.map((link) => (
                <li
                  className={s.policyLink}
                  key={link.id}
                  onClick={() => sendEvent(EventType.FooterT, { name: link.label })}
                >
                  <Href className={s.policyLink} href={link.path} linkType="pathname" target="_blank">
                    {link.label}
                  </Href>
                </li>
              ))}
            </ul>
            {footNote}
          </Flex>
        </div>
      </div>
    </footer>
  )
}
